import { notifyError, useNotifications } from 'Logic/Notifications.js'

import useDataOnActionCancelOAuth2AuthorizationCodeConnection from './useDataOnActionCancelOAuth2AuthorizationCodeConnection.js'
import useDataOnActionConnectApiToken from './useDataOnActionConnectApiToken.js'
import useDataOnActionConnectHttpJwt from './useDataOnActionConnectHttpJwt.js'
import useDataOnActionConnectOAuth2AuthorizationCode from './useDataOnActionConnectOAuth2AuthorizationCode.js'
import useDataOnActionConnectOAuth2ClientCredentials from './useDataOnActionConnectOAuth2ClientCredentials.js'
import useDataOnActionOAuth2AuthorizationCodeConnected from './useDataOnActionOAuth2AuthorizationCodeConnected.js'
import useDataOnActionUninstall from './useDataOnActionUninstall.js'
import { useRef } from 'react'

export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let authWindow = useRef(null)
  let onActionConnectApiToken = useDataOnActionConnectApiToken(
    props,
    data,
    reExecuteQuery
  )
  let onActionConnectOAuth2AuthorizationCode =
    useDataOnActionConnectOAuth2AuthorizationCode(props, data, reExecuteQuery)
  let onActionConnectOAuth2ClientCredentials =
    useDataOnActionConnectOAuth2ClientCredentials(props, data, reExecuteQuery)
  let onActionCancelOAuth2AuthorizationCodeConnection =
    useDataOnActionCancelOAuth2AuthorizationCodeConnection(
      props,
      data,
      reExecuteQuery
    )
  let onActionOAuth2AuthorizationCodeConnected =
    useDataOnActionOAuth2AuthorizationCodeConnected(props, data, reExecuteQuery)
  let onActionUninstall = useDataOnActionUninstall(props, data, reExecuteQuery)
  let onActionConnectHttpJwt = useDataOnActionConnectHttpJwt(
    props,
    data,
    reExecuteQuery
  )

  let [, notify] = useNotifications()

  return async function onSubmit({ value, args, change }) {
    switch (args.type) {
      case 'connect-api-token': {
        return await onActionConnectApiToken({ value, args, change })
      }

      case 'connect-http-jwt': {
        return await onActionConnectHttpJwt({
          value,
          args,
          change,
        })
      }

      case 'connect-oauth2-authorization-code': {
        return await onActionConnectOAuth2AuthorizationCode({
          value,
          args: {
            ...args,
            authWindow,
          },
          change,
        })
      }

      case 'connect-oauth2-client-credentials': {
        return await onActionConnectOAuth2ClientCredentials({
          value,
          args,
          change,
        })
      }

      case 'cancel-oauth2-authorization-code-connection': {
        return await onActionCancelOAuth2AuthorizationCodeConnection({
          value,
          args: {
            ...args,
            authWindow,
          },
          change,
        })
      }

      case 'oauth2-authorization-code-connected': {
        return await onActionOAuth2AuthorizationCodeConnected({
          value,
          args,
          change,
        })
      }

      case 'refetch': {
        reExecuteQuery({ requestPolicy: 'network-only' })
        return
      }

      case 'uninstall': {
        return await onActionUninstall({
          value,
          args,
          change,
        })
      }

      default: {
        return notify(notifyError('Invalid action'))
      }
    }
  }
}
